import { Reveal } from "@/components/Reveal";
import { SECTORES } from "@/data/content";

export const Sectores = () => {
  return (
    <section
      id="sectores"
      data-testid="sectores-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        <Reveal>
          <p className="text-sm font-medium text-[#E60000] tracking-[0.2em] uppercase mb-6">
            {SECTORES.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] leading-tight">
            {SECTORES.title}
          </h2>
          <p className="text-lg font-light text-[#525252] leading-relaxed mt-8">
            {SECTORES.description}
          </p>

          <h3 className="text-sm font-bold text-[#0A0A0A] uppercase tracking-[0.15em] mt-12 mb-6">
            {SECTORES.advantageTitle}
          </h3>
          <p className="text-[#525252] leading-relaxed">{SECTORES.advantage}</p>
        </Reveal>

        <Reveal delay={0.15} className="lg:pt-2">
          <h3 className="text-sm font-bold text-[#0A0A0A] uppercase tracking-[0.15em] mb-2">
            {SECTORES.sectorsTitle}
          </h3>
          <ul className="divide-y divide-[#E5E5E5] border-t border-[#E5E5E5] mt-4">
            {SECTORES.sectors.map((sector, i) => (
              <li
                key={sector}
                data-testid={`sector-${i}`}
                className="flex items-center py-6 group cursor-default"
              >
                <span className="text-lg md:text-xl font-medium text-[#0A0A0A] group-hover:text-[#E60000] transition-colors duration-200">
                  {sector}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default Sectores;
